import { Text, Stack, Box } from 'braid-design-system';
import { decode } from 'html-entities';
import type { ComponentProps } from 'react';

import HotjarMask from '../../components/common/HotjarMask';

import * as styles from './styles.css';

type StackProps = ComponentProps<typeof Stack>;

const parseAndSplitHtmlText = (input: string) => {
  // Double decode to handle quirky behaviours of some characters being saved on the backend, so far we know:
  // " saved as &amp;quote; instead of &quote;
  // > saved as &amp;gt; instead of &gt;
  // < saved as &amp;lt; instead of &lt;
  // & saved as &amp;amp; instead of &amp;
  const decodedInput = decode(decode(input));
  return decodedInput.split('<br />').filter((line) => line.trim() !== '');
};

interface Props {
  content: string;
  isSecondary?: boolean;
  size?: 'standard' | 'small' | 'xsmall' | 'large';
  space?: StackProps['space'];
}

export const HtmlContent: React.FC<Props> = ({
  content,
  isSecondary = true,
  size = 'standard',
  space = 'small',
}) => (
  <Stack space={space}>
    {parseAndSplitHtmlText(content).map((lines, index) => (
      <Text
        key={index}
        tone={isSecondary ? 'secondary' : 'neutral'}
        size={size}
      >
        <HotjarMask>
          <Box className={styles.textFormatting}>{lines}</Box>
        </HotjarMask>
      </Text>
    ))}
  </Stack>
);
